//LOCAL BACKEND
//export const Backend_URL = "http://localhost:8080";

//WEBSERVICE BACKEND
export const Backend_URL = "https://teamflowbackend.adaptable.app";